import { Component, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FastAPIService } from '../../service/fast-api.service';
import { first, filter, lastValueFrom, timeInterval } from 'rxjs';
import { FormControl } from '@angular/forms';
import { ConfirmationService, MessageService, PrimeIcons,TreeNode, TreeTableNode } from 'primeng/api';
import { NgModule } from '@angular/core';
import { Router } from '@angular/router';

import * as XLSX from 'xlsx';  
import { FileUpload } from 'primeng/fileupload';

interface Type {
  name: string;
  code: string;
}


@Component({
  selector: 'app-import-dictionary',
  templateUrl: './import-dictionary.component.html',
  styleUrls: ['./import-dictionary.component.scss']
})
export class ImportDictionaryComponent implements OnInit{
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  background = "assets/web-scraping-component-images/background.svg";
  mainIcon = "assets/web-scraping-component-images/mainIcon.svg";
  deleteBtnIcon = "assets/web-scraping-component-images/delete.svg";
  createBtnIcon = "assets/web-scraping-component-images/add.svg";
  orderIcon = "assets/web-scraping-component-images/order.svg";
  upIcon = "assets/web-scraping-component-images/up.svg";
  downIcon = "assets/web-scraping-component-images/down.svg";
  viewBtnIcon = "assets/web-scraping-component-images/view.svg";
  viewBtnActiveIcon = "assets/web-scraping-component-images/viewActive.svg";
  checkBtnIcon = "assets/web-scraping-component-images/savePending.svg";
  checkBtnActiveIcon = "assets/web-scraping-component-images/checkActive.svg";
  toBeginningIcon = "assets/web-scraping-component-images/start.svg";
  nextIcon = "assets/web-scraping-component-images/next.svg";
  backIcon = "assets/web-scraping-component-images/back.svg";
  toLastIcon = "assets/web-scraping-component-images/last.svg";
  calenderIcon = "assets/web-scraping-component-images/calendar.svg";
  loadingIcon = "assets/web-scraping-component-images/loading.svg";
  fetchIcon = "assets/web-scraping-component-images/fetchIcon.svg";
  arrowRight = "assets/web-scraping-component-images/Arrow - Right 3.svg"
  restartIcon = "assets/web-scraping-component-images/restartBtn.svg"


  filterName: string = "";
  filterStartDate: string = "";
  filterEndDate: string = "";
  filterStatus: string = "";
  filterDataSource: string = "";
  updateType: FormControl = new FormControl();
  accessToken: string = "";
  username: string = "";
  password: string = "";
  scrapingTypeSelected: FormControl = new FormControl('');
  scriptSelected: FormControl = new FormControl();
  scriptStartPage: FormControl = new FormControl();
  scriptStopPage: FormControl = new FormControl();

  select_all: boolean = false;
  dialog_visible: boolean = false;
  goto_dialog_visible: boolean = false;
  forceSaveSolr: boolean = false;
  reverseId: boolean = false;
  reverseDate: boolean = false;
  reverseQuantity: boolean = false;
  requireAuthentication: boolean = false;

  pageSize: number = 10;
  currentPage: number = 1;
  totalRecord: number = 0;
  gotoPage: number = this.currentPage;

  todayDate: Date = new Date();
  Activate:boolean = false;

  // requestList: WebRequest[] = [];
  requestList: DictionanaryRequest[]=[];
  selectedRequestList: string[] = [];
  selectedAttemptList: string[] = [];
  displayRequestList: number[] = [];
  dataSourceList: any[] = [];
  filterStatusOption: string[] = ["Any", "Fetch Pending", "Fetching", "Analysis Pending", "Analyzing","Geocode Pending", "Geocoding", "Save Pending","Saving", "Saved"];
  filterDataSourceOption: string[] = ["Any"];
  scrapingTypes: string[] = ['News', 'Social Media', 'File'];
  pageSizeList: number[] = [10, 15, 20];
  fileScriptList: any[] = [];
  isAppend:boolean = false;

  

  sortBy: string = 'Status';
  sortOrder: string = 'desc';
  information:string = "";
  updateTypes: Type[] = [];
 

  loading: boolean = false;
  colectTotalPage: number = 0;
  allRequestList: any[] = [];
  filteredList: any[] = [];
  isFiltered: boolean = false;

  constructor(private fastService: FastAPIService, private messageService: MessageService, private confirmationService: ConfirmationService, private route: Router) {
    // setInterval(() => {this.reload()}, 10000);
  }

  async ngOnInit(): Promise<void> {
    this.loading = true;
    await this.getRequestList();
    this.loading = false;
    this.todayDate = new Date();
  }

  reload() {
    this.getRequestList();
  }

  gettingRequest: Boolean = false;
  async getRequestList() {
    if(this.gettingRequest)  return;
    this.gettingRequest = true
    this.requestList = [];
    this.allRequestList = []
    const response = await lastValueFrom(this.fastService.getDictionaryTreeList(Math.max(this.getRequestBegin(), 0), this.pageSize,this.sortBy,this.sortOrder));
    if(response.status_code == 404) return;

    this.totalRecord = response.response.total;
    const res = await lastValueFrom(this.fastService.getDictionaryTreeList(0,this.totalRecord,this.sortBy,this.sortOrder));
    this.allRequestList = res.response.data
    if (response.status_code == 404) return;

    const requests: any[] = response.response.data;
    for (let request of requests) {
      if(!this.filterDataSourceOption.includes(request.Filename ? request.Filename : request.ScrapingScript))  this.filterDataSourceOption.push(request.Script ? request.Scripe : request.ScrapingScript);
      this.requestList.push(request)
    }
  if (this.isFiltered) {
          this.onApplyClick();
      } else {
          this.updateRequestList();
      }
    this.getTreeNode()
    this.gettingRequest = false;
  }



  onClearClick() {
    this.filterName = "";
    this.filterStartDate = "";
    this.filterEndDate = "";
    this.isFiltered = false;
    this.filteredList = [];
  }
  
  async onApplyClick() {
    this.loading = true;
    await this.getRequestList();
    this.loading = false;

    this.currentPage = 1;

    this.filteredList = [...this.allRequestList];

    if (this.filterName != "") {
      this.filteredList  = this.filteredList.filter((request) => {
        return request.Filename == this.filterName;
      });
    }

    if (this.filterStartDate != "") {
      this.filteredList = this.filteredList.filter((request) => {
        return new Date(request.Date).getTime() >= new Date(this.filterStartDate).getTime();
      });
    }

    if (this.filterEndDate != "") {
      this.filteredList = this.filteredList.filter((request) => {
        return new Date(request.Date).getTime() <= new Date(this.filterEndDate).getTime() + 86399000;
      });
    }
    this.isFiltered = this.filteredList.length !== this.allRequestList.length;
    this.getTreeNode();
    this.updateRequestList();
    this.totalRecord = this.filteredList.length;
    this.gettingRequest = false;
  }


  async onDeleteClick(Dict: any) {
    this.confirmationService.confirm({
      message: 'Do you want to delete ?', 
      accept: async () => {
        const response = await lastValueFrom(this.fastService.removeDictionary(Dict._id));
        console.log("res",response);
        this.messageService.add({severity: response.status, summary: response.message})
        await this.getRequestList();
      }
    })
  }

  onDownloadClick(Dict: any) {
    this.fastService.downloadDictionary(Dict._id).subscribe((response: Blob) => {
      const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = Dict.Filename || 'downloaded_file';
      document.body.appendChild(a);
      a.click();

      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }, error => {
      console.error('Download failed', error);
    });
  }

  onDownloadTemplate(Dict: any) {
    const templateUrl = 'assets/import-dictionary/Dictionary_Template.xlsx';

    fetch(templateUrl)
      .then(response => response.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Dictionary_Template.xlsx';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
      .catch(error => {
        console.error('Download failed', error);
      });
  }

  onImportClick() {
    this.dialog_visible = true;
    this.forceSaveSolr = false;
    this.information = '';
    this.requireAuthentication = false;
    if (this.fileUpload) {
      this.fileUpload.clear();
    }
    this.isDocx = false;
    this.updateType.setValue({});
    this.scriptStartPage.setValue(1);
    this.scriptStopPage.setValue(1);
  }

  onToBeginningClick() {
    this.currentPage = 1;
    this.updateRequestList();
  }

  calculateList(): number[] {
    this.displayRequestList = [];
    for(let i = (this.currentPage - 1) * this.pageSize; i < Math.min(this.requestList.length, (this.currentPage * this.pageSize)); i++) {
      this.displayRequestList.push(i);
    }

    return this.displayRequestList;
  }

  onPageSizeChange(event: any) {
    //console.log(event)
    //this.currentPage = Math.ceil(begin / event.value);
    this.currentPage = 1;
    this.updateRequestList();
    }

  updateRequestList() {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    this.requestList = this.isFiltered 
        ? this.filteredList.slice(start, end)
        : this.allRequestList.slice(start, end);
    this.getTreeNode();
}

  getSelectedList(treeNode: any): number {
    this.selectedRequestList = [];
    this.selectedAttemptList = [];
    if(!treeNode.length)  return 0;
    for(let node of treeNode) {
      if(node.data.id == null)  continue;
      const id = node.data.id;
      if(node.children)  this.selectedRequestList.push(id);
      else  this.selectedAttemptList.push(id);
    }
    return this.selectedRequestList.length + this.selectedAttemptList.length;
  }

  getRequestBegin() {
    return Math.min(((this.currentPage - 1) * this.pageSize), this.totalRecord - 1);
  }

  getRequestEnd() {
    return Math.min(this.totalRecord, this.getRequestBegin() + this.pageSize);
  }

  onBackClick() {
    if(!this.totalRecord)return;
    this.currentPage = Math.floor(Math.max(1, this.currentPage - 1));
    this.updateRequestList();
  }

  onNextClick() {
    if(!this.totalRecord)return;
    this.currentPage = Math.min(this.currentPage + 1, Math.ceil(this.totalRecord / this.pageSize));
    this.updateRequestList();
  }

  onToLastClick() {
    if(!this.totalRecord)return;
    this.currentPage = Math.ceil((this.totalRecord / this.pageSize));
    this.updateRequestList();
  }

  onPageNumberClick() {
    if(!this.totalRecord)return;
    this.gotoPage = this.currentPage;
    this.goto_dialog_visible = true;
    this.updateRequestList();
  }

  getGotoOptions() {
    let options: number[] = [];
    for(let i = 1; i <= Math.ceil(this.totalRecord / this.pageSize); i++) {
      options.push(i);
    }
    return options;
  }

  onGotoClick() {
    if(!this.totalRecord)return;
    this.currentPage = this.gotoPage;
    this.goto_dialog_visible = false;
    this.updateRequestList();
  }

  goto(page: number) {
    this.currentPage = page;
    this.updateRequestList();
  }
  onCancelClick() {
    this.dialog_visible = false;
  }



  isActiveButton(page: number): boolean {
    let length = Math.ceil(this.totalRecord / this.pageSize);

    if(page <= 0 || page > length) {
      return false;
    }

    if(page == this.currentPage - 4) {
      return this.currentPage == length;
    }
    
    if(page == this.currentPage - 3) {
      return this.currentPage + 1 >= length;
    }

    if(page == this.currentPage + 4) {
      return this.currentPage == 1;
    }

    if(page == this.currentPage + 3) {
      return this.currentPage <= 2;
    }

    return true;
  }
  

  onClickActiveButton(evt: any,Dict_ID:any){
    const isChecked = evt.checked;
    evt.checked = !isChecked;
    
    this.confirmationService.confirm({
      message: `Do you want to ${isChecked ? 'Activate' : 'Deactivate'}?`,
      accept: async () => {
        this.fastService.activateDictionary(Dict_ID).subscribe((response: any) => {
          this.getRequestList();
          this.messageService.add({severity: response.status, summary: response.message});
        });
      },
      reject: () => {
        const findDict = (id: string) => {
          for (const dict of this.requestList) {
            // if (dict._id === id) return dict;
            // console.log("parent ",dict)
            const childDict = dict.AdditionalDict?.find(child => child._id === id);
            console.log('child dict',childDict)
            if (childDict) return childDict;
          }
          return null;
        };
        const rejectedDict = findDict(Dict_ID);
      if (rejectedDict) {
        rejectedDict.Status = !isChecked; 
      }
        evt.checkActive = !isChecked
      }
    });
    this.gettingRequest = false;
  }


  onSort(event: any){
    if (this.sortBy !== event.field || this.sortOrder !== (event.order === 1 ? 'asc' : 'desc')) {
    this.sortBy = event.field;
    this.sortOrder = event.order === 1 ? 'asc' : 'desc';
    if (!this.gettingRequest) {
      this.getRequestList();
    }  
    }
  }



treeNode: TreeNode[] = [];
selectedTreeNode: TreeTableNode | TreeTableNode[] | null = [];
getTreeNode() {
  let treeNodeTemp: TreeNode[] = [];
  //make root nodes
  
  for(let request of this.requestList) {
    let rootNode: TreeNode = {
      data: request,
      children: [],
    }

    rootNode.data.hasChildren = true;
    if(rootNode.data.Script)  rootNode.data.ScrapingScript = rootNode.data.Script;

    for(let attempt of request.AdditionalDict) {
      let node: TreeNode = {
        data: attempt
      }
      
      rootNode.children?.push(node);
      // rootNode.data.Quantity += node.data.Quantity
    }

    for(let node of this.treeNode) {
      if(node.data._id == rootNode.data._id) {
        rootNode.expanded = node.expanded;
        break;
      }
    }
    treeNodeTemp.push(rootNode);
  }
  this.treeNode = treeNodeTemp;
  this.gettingRequest = false;
}


  uploadedFiles: any;
  storeData: any;
  jsonData: any;    
  worksheet: any;
  filefields: string[] = [];
  isDocx: boolean = false;

  uploadHandler(event: any) {
    this.uploadedFiles = event.files[0];
    const fileName: string = this.uploadedFiles.name;
    const fileType = fileName.split('.').pop();
    this.isDocx = fileType == "docx";
    if (this.isDocx) return;
    let readFile = new FileReader();
    readFile.onload = (e) => {
      this.storeData = readFile.result;
      var data = new Uint8Array(this.storeData);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var first_sheet_name = workbook.SheetNames[0];
      this.worksheet = workbook.Sheets[first_sheet_name];
      this.jsonData = XLSX.utils.sheet_to_json(this.worksheet, { raw: false });
      this.filefields = Object.keys(this.jsonData[0]);
    }
    readFile.readAsArrayBuffer(this.uploadedFiles)
  }


  onRemove(event: any) {
    this.uploadedFiles = null;
    this.isDocx = false;
  }

async onFileSaveClick() {
  if(!this.uploadedFiles){
    alert("Please select the file to upload.")
    return;
  }

  let data: FormData = new FormData();
      data.append('File', this.uploadedFiles);
      data.append('Information', this.information);

    this.confirmationService.confirm({
      message: 'Request Comfirmation', 
      accept: async () => {
        this.fastService.uploadReplaceDictionaryFile(data).subscribe(async (response)=>{
          this.messageService.add({severity: response.status, summary: response.message})
          await this.getRequestList();
          this.information = "";
          this.dialog_visible = false;
          this.onApplyClick();
          this.onClearClick();
        }) 
      }
    })
}

dictID:string =""
onUploadClick(Dict_ID:string) {
  this.dictID = Dict_ID;
  this.dialog_visible = true;
  this.forceSaveSolr = false;
  this.information = '';
  this.requireAuthentication = false;
  if (this.fileUpload) {
    this.fileUpload.clear();
  }
  this.isDocx = false;
  this.updateType.setValue({});
  this.scriptStartPage.setValue(1);
  this.scriptStopPage.setValue(1);
  this.isAppend = true;
}

uploadDictionaryAppend(){
  if(!this.uploadedFiles){
    alert("Please select the file to upload.")
    return;
  }
  let data: FormData = new FormData();
      data.append('File', this.uploadedFiles);
      data.append('Information', this.information);

    this.confirmationService.confirm({
      message: 'Request Comfirmation', 
      accept: async () => {
        this.fastService.uploadAppendDictionaryFile(this.dictID,data).subscribe(async (response)=>{
          this.messageService.add({severity: response.status, summary: response.message})
          await this.getRequestList();
          this.information = "";
          this.dialog_visible = false;
        }) 
      }
    })
    this.isAppend = false;
}
}


export class DictionanaryRequest{
  _id: string = "" ;
  Filename: string = "";
  Date: string ="";
  Information:string ="";
  Quantity: number = 0;
  AdditionalDict: DictionaryAttempt[] = [];
  Status: boolean = false;
  RequestID: any;
}
export class DictionaryAttempt {
  _id: string = "" ;
  REPLACE_id: string = "";
  Filename: string = "";
  Date: string ="";
  Information:string ="";
  Quantity: number = 0;
  Status: boolean = false;
  UpdateType: string = "";
}


// export class NewsFields {
//   [key: string]: string[];
// }